import { Api } from "@mcleod/core";
import { AutogenLayoutFuelTransactionHistoryReport } from "./autogen/AutogenLayoutFuelTransactionHistoryReport";
import { LayoutProvidedReportDecoratorProps } from "@mcleod/components";

export class FuelTransactionHistoryReport extends AutogenLayoutFuelTransactionHistoryReport {
  
    override async onLoad(): Promise<void> {
        this.textboxFuelInterfaceId.visible = false;
        Api.search("lme/dispatch/asset/fuel-interface-configured", {}).then(async (response) => {
            this.textboxFuelInterfaceId.visible = response.data.length >= 2;
            this.textboxFuelInterfaceId.required = response.data.length >= 2;

        });
    }

     get reportDecoratorProps(): Partial<LayoutProvidedReportDecoratorProps> {
        return {
            doOnResetForm: () => Api.search("lme/dispatch/asset/fuel-interface-configured", {}).then(async (response) => {
                this.textboxFuelInterfaceId.visible = response.data.length >= 2;
                this.textboxFuelInterfaceId.required = response.data.length >= 2;

            })
        };
    }
}

 


